<app-page-title [title]="title"></app-page-title>

<div class="row">
  <div class="col-md-12">
    <app-data-table [columnHeader]="tableColumns" [tableData$]="firms$" [pageLength]="pageLengths" [pageIndex]="pageIndexs"
         (pageChanged)="onPageChanged($event)">
      <ng-template let-data="data">
        <div class="action-icons">
          <button mat-icon-button [matMenuTriggerFor]="menu" matTooltip="Actions">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="redirectToProfile(data)">
              <mat-icon>visibility</mat-icon>
              <span>View Application</span>
            </button>
        </mat-menu>
        </div>
      </ng-template>
    </app-data-table>
  </div>
</div> 